import React from "react"

export default props => <h1 style={{ textAlign: "center" }}>{props.headerText}</h1>